import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import 'fabric';
declare const fabric: any;
import * as moment from 'moment';
@Component({
  selector: 'app-signature-canvas',
  templateUrl: './signature-canvas.component.html',
  styleUrls: ['./signature-canvas.component.scss']
})
export class SignatureCanvasComponent implements OnInit {
  @Output() clearFieldValue = new EventEmitter < any > ();
  @Input() fieldvalue;
  @Input() fieldId: any;
  @Output() signatureImage = new EventEmitter < any > ();
  @Input() basedOnEditability: string;
  @Input() signaturePreview: any;
  @Input() sectionDynamic: any;
  showText = false;
  canvas;
  basedIndex = 0;
  constructor() {}
  ngOnInit() {
  
  }
  ngAfterViewInit(){
    this.InitThis();
    this.appedbase64path();
    if(this.signaturePreview && this.sectionDynamic && ((this.fieldId + this.basedIndex) !== (this.fieldId + this.basedIndex))){
      this.basedIndex++;
    }
  }
  InitThis() {
    if(this.signaturePreview && this.sectionDynamic){
    this.canvas = new fabric.Canvas(this.fieldId + this.basedIndex, { isDrawingMode: true });
    }else{
      this.canvas = new fabric.Canvas(this.fieldId, { isDrawingMode: true });
    }
    this.canvas.freeDrawingBrush.width = 4;
    this.canvas.backgroundColor = 'white';
    this.canvas.on('mouse:down', () => {
      if (!this.signaturePreview && !this.showText) {
        this.findMe();
      }
      this.showText = true;
      this.canvas.on('mouse:out', () => {
        this.signatureImage.emit({ thumbnail: this.removeBaseString(this.canvas.toDataURL()) });
      })
    })

  }
  findMe() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.showPosition(position);
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }
  showPosition(position) {
    var text = new fabric.Text('Date: ' + moment().format('L') + ', Time: ' + moment(new Date()).format('LT') + '\n', { left: 20, top: 120, fontSize: 12 });
    this.canvas.add(text);
    var text1 = new fabric.Text('Location: ' + position.coords.latitude.toFixed(5) + ', ' + position.coords.longitude.toFixed(5) + '\n', { left: 20, top: 140, fontSize: 12 });
    this.canvas.add(text1);
  }
  clearArea() {
    this.canvas.clear();
    this.clearFieldValue.emit();
    this.showText = false;
  }

  appedbase64path() {
    if (this.signaturePreview && this.signaturePreview !== ' ') {
      let self = this;
      fabric.Image.fromURL(this.getBase64String(this.signaturePreview.thumbnail), function(myImg) {
        self.canvas.add(myImg);
      });
    }
  }

  getBase64String(str) {
    return 'data:image/jpg;base64,' + str;
  }
  removeBaseString(base64String) {
    let thumbImageUrl = base64String.replace('data:image/png;base64,', '');
    thumbImageUrl = thumbImageUrl.replace('data:image/jpeg;base64,', '');
    return thumbImageUrl;
  }
}



// WEBPACK FOOTER //
// ./src/app/rFF/signature-canvas/signature-canvas.component.ts